module.exports = __webpack_public_path__ + "img/815.92b629c2.png";